import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { kebabCase } from "lodash";

const ServiceTypesContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 ${({ parent }) => (parent === "BusinessSearchResult" ? "0" : "0.375rem")} 0;
  padding: 0;
`;

const Tag = styled.li`
  background-color: ${({ theme }) => theme.themeColors.blue1};
  border-radius: 0.71875rem;
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  font-size: ${({ theme }) => theme.fontSize(0)};
  font-weight: 600;
  letter-spacing: 0.01875rem;
  line-height: 0.75rem;
  list-style-type: none;
  margin: 0 0.375rem 0.375rem 0;
  padding: 0.25rem 0.625rem 0.125rem 0.625rem;
  text-transform: uppercase;

  :last-child {
    margin-right: 0;
  }
`;

function ServiceTypePills({ serviceTypes, businessName, parent }) {
  const serviceNames = serviceTypes.map((serviceType) => serviceType.attributes.name);
  const arr = [];
  if (serviceNames.filter((s) => s.includes("Grooming")).length > 0) {
    arr.push("GROOMING");
  }
  if (serviceNames.filter((s) => s.includes("Training")).length > 0) {
    arr.push("TRAINING");
  }
  if (serviceNames.filter((s) => s.includes("Veterinary")).length > 0) {
    arr.push("VETERINARY");
  }

  return (
    <ServiceTypesContainer parent={parent}>
      {arr.map((serviceType) => {
        return <Tag key={`${serviceType}-${kebabCase(businessName)}`}>{serviceType}</Tag>;
      })}
    </ServiceTypesContainer>
  );
}

export default ServiceTypePills;

ServiceTypePills.propTypes = {
  businessName: PropTypes.string.isRequired,
  serviceTypes: PropTypes.arrayOf(PropTypes.object),
  parent: PropTypes.string,
};

ServiceTypePills.defaultProps = {
  serviceTypes: [],
  parent: "",
};
